import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AuthenticationService } from '../../core/services/authentication.service';
import { PasswordResetService } from '../../core/services/password-reset.service';
import { PasswordResetToken } from '../../core/model/password-reset-token';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-password-reset',
  template: ''
})
export class PasswordResetComponent implements OnInit {
  passwordResetToken: PasswordResetToken;

  form: FormGroup;
  requestError: Boolean;
  requestProcessing: Boolean;
  private subscription_auth;
  bodyClasses = 'login';
  body: HTMLBodyElement = document.getElementsByTagName('body')[0];

  username: string;
  constructor(
    private fb: FormBuilder,
    private auth: AuthenticationService,
    private router: Router,
    private translateService: TranslateService,
    private passwordResetService: PasswordResetService,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.passwordResetToken = this.passwordResetService.getToken();
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      const token = params.get('token');
      if (token !== null) {
        try {
          this.passwordResetToken = new PasswordResetToken(token);
          this.passwordResetService.updateToken(this.passwordResetToken);
        } catch (error) {
          this.passwordResetService.resetToken();
        }
      } else {
        this.passwordResetService.resetToken();
      }
      this.router.navigate(['../passwordNew']);
    });
  }
}
